import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { MonitoringAnalysisPage } from '@/areas/market-insights/MarketInsights/pages/ChartsDetailsPage';
import type { PageStaticData } from '@/shared/routing';

// The monitoring layout (`monitoring/route.tsx`) checks who may open this page.
export const Route = createFileRoute('/_authenticated/monitoring/analysis')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ state: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <MonitoringAnalysisPage />;
}
